import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Styles from "./SigningIn.module.css";
import { useDispatch, useSelector } from "react-redux";
import { slackConnectConfirm } from "../../reducers/loginReducer";
function AuthRedirect(props) {
  let dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();

  let slackConnectConfirmData = useSelector(state => state.loginReducer.slackConnectConfirmation);
  let slackConnectConfirmError = useSelector(state => state.loginReducer.slackConnectConfirmationError);
  useEffect(() => {
    let code = searchParams.get("code");
    let state = searchParams.get("state");
    let error = searchParams.get("error");
    dispatch(slackConnectConfirm({ code, state, error }));
    // if(error){
      
    // }else{
    //   window.opener.postMessage({ type:'auth_redirect' ,success: true, code }, "*");
    // }
    // const timeoutId = setTimeout(() => {
    //   window.close();
    // }, 5000);

    // // Cleanup function to prevent the timeout from being cleared on unmount
    // return () => clearTimeout(timeoutId);
  }, []);

  useEffect(()=>{
    if(slackConnectConfirmError){
      window.opener.postMessage({ type:'auth_redirect' ,success: false, error:"Something went wrong, Please try again" }, "*");
        window.close();
    }
  },[slackConnectConfirmError])

  useEffect(()=>{
    if(slackConnectConfirmData){
      window.opener.postMessage({ type:'auth_redirect' ,success: true }, "*")
        window.close();
    }
  },[slackConnectConfirmData])

  return (
    <div className={Styles.container}>
      <div className={Styles.signingTextBox}>
        <p className={Styles.signingText1}>Processing...</p>
        <div className={Styles.signingInfoWrapper}>
          <p className={Styles.signingInfoText1}>Do you know?</p>
          <p className={Styles.signingInfoText2}>
            Botza is your personal magic wand, that increases functionality of
            Slack and MS Teams by 10x
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuthRedirect;
